import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import styles from './TheoryTestPage.module.css';
import { PageTitle } from '../../ui-components/PageTitle/PageTitle';
import { LinkWrapper } from '../../ui-components/LinkWrapper/LinkWrapper';
import SeoLinks from '../../components/SeoLinks/SeoLinks';

const TheoryTestPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Container>
        <Row>
          <Col>
            <PageTitle>{t('theoryTestPage.title1')}</PageTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.text}>
              <div>
                <Trans i18nKey="theoryTestPage.text11">
                  desc
                  <LinkWrapper to="/">Theorieprüfung</LinkWrapper>
                  desc
                  <LinkWrapper to="/">Theorie24.ch</LinkWrapper>
                  desc
                </Trans>
              </div>
              <div>{t('theoryTestPage.text12')}</div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.subtitle}>{t('theoryTestPage.title2')}</div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.text}>
              <Trans i18nKey="theoryTestPage.text2">
                desc
                <LinkWrapper to="/">theorie24.ch</LinkWrapper>
                desc
              </Trans>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.subtitle}>{t('theoryTestPage.title3')}</div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.text}>
              <Trans i18nKey="theoryTestPage.text3">
                desc
                <LinkWrapper to="/offers">Registrieren</LinkWrapper>
                desc
              </Trans>
            </div>
          </Col>
        </Row>

        <Row className={styles.links}>
          <SeoLinks />
        </Row>
      </Container>
    </div>
  );
};

export default TheoryTestPage;
